import { useTranslation } from 'react-i18next';

import type { PositionSource } from './types';

export type PositionSourceBadgeProps = {
  positionSource: PositionSource;
};

export function positionSourceIcon(positionSource: PositionSource): string {
  switch (positionSource) {
    case 'manual':
      return 'Images/Icons/map-manual.svg';
    case 'aml':
      return 'Images/Icons/map-aml.svg';
    case 'eed':
      return 'Images/Icons/map-eed.svg';
    default:
      return 'Images/Icons/map-device.svg';
  }
}

export function PositionSourceBadge({ positionSource }: PositionSourceBadgeProps) {
  const { t } = useTranslation();

  const effectiveText = (() => {
    switch (positionSource) {
      case 'mobileApp':
        return t('PositionSource_MobileApp_Label');
      case 'webApp':
        return t('PositionSource_WebApp_Label');
      case 'manual':
        return t('PositionSource_Manual_Label');
      case 'aml':
        return 'AML';
      case 'eed':
        return 'EED';
      default:
        return '—';
    }
  })();

  return (
    <span className="p-1 d-flex flex-row gap-1 align-items-center">
      <img src={positionSourceIcon(positionSource)} alt="" className="mr-2" style={{ height: '28px' }} />
      <span>{effectiveText}</span>
    </span>
  );
}
